















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { i18n } from '@/i18n';
import { compass } from '@resclick/compass';
import { IPlace, IProductProperty, IProductType, IProperty, PassengerDto } from '@resclick/data-access';
import moment from 'moment';
import { Getter, Mutation } from 'vuex-class';
import { date } from 'quasar';
import formatDate = date.formatDate;
import FlightList from '@/views/sale/flight-list.vue';

@Component({
  components: { FlightList },
})
export default class Flights extends Vue {
  @Getter('widget/market') market!: IPlace;
  @Getter('widget/property') property!: IProperty;
  @Getter('cart/products') products!: IProductType[];
  @Mutation('cart/addToCart') addToCart!: any;
  @Mutation('cart/removeFromCart') removeFromCart!: any;

  flightOffer = false;

  airportAutocompletes: any = {
    arrival: [],
    departure: [],
  };

  query = {
    departure: '',
    arrival: '',
    direction: 'ROUND_TRIP',
  };

  formatDate = formatDate;

  numOfPassengers: 'ALL' = 'ALL';

  notFound = false;

  isSearchingFlights = false;

  selected: any = {
    outboundFlight: null,
    returnFlight: null,
  };

  offers: { outboundFlights: any[]; returnFlights: any[] } = {
    outboundFlights: [],
    returnFlights: [],
  };

  get totalPrice() {
    let total = 0;
    const { price: outboundPrice = {}, isBundle } = this.selected.outboundFlight || {};
    const { price: returnPrice = {}, bundlePrice } = this.selected.returnFlight || {};

    const { currency } = outboundPrice;

    if (isBundle && bundlePrice) {
      total = bundlePrice.amount;
    } else {
      total += outboundPrice?.amount || 0;
      total += returnPrice?.amount || 0;
    }

    return {
      amount: total,
      currency,
    };
  }

  get outboundFlights() {
    return this.offers.outboundFlights;
  }

  get returnFlights() {
    const outboundFlight = this.selected.outboundFlight;

    if (outboundFlight) {
      return this.offers.returnFlights.filter((flight) => {
        if (outboundFlight.isBundle) {
          return flight.scope?.includes(outboundFlight.id);
        } else {
          return !flight.scope || !flight.scope.length;
        }
      });
    }

    return [];
  }

  get offerOptions() {
    return [
      { label: i18n.t('GENERAL.NO_I_DONT_WANT'), value: false },
      { label: i18n.t('GENERAL.YES_I_WANT'), value: true },
    ];
  }

  get directionOptions() {
    return [
      { label: i18n.t('GENERAL.ROUND_TRIP'), value: 'ROUND_TRIP' },
      { label: i18n.t('GENERAL.ONE_WAY'), value: 'ONE_WAY' },
    ];
  }

  get numOfPassengersOptions() {
    return [{ label: i18n.t('GENERAL.ALL_PASSENGERS'), value: 'ALL' }];
  }

  @Watch('query.direction')
  onDirectionChange() {
    if (this.outboundFlights) {
      this.selected = {
        outboundFlight: null,
        returnFlight: null,
      };
      this.offers = {
        outboundFlights: [],
        returnFlights: [],
      };

      this.$nextTick(() => this.searchFlights());
    }
  }

  @Watch('selected.outboundFlight')
  onSelectedOutboundChange() {
    this.selected.returnFlight = null;
  }

  @Watch('selected', { deep: true })
  onSelected(value: any) {
    const prevFlightIndex = this.products.findIndex((p) => p.productCategory === 'FLIGHT');
    if (prevFlightIndex > -1) this.removeFromCart(prevFlightIndex);

    if (this.query.direction === 'ROUND_TRIP') {
      if (value.outboundFlight && value.returnFlight) {
        this.addToCart({
          type: 'FLIGHT',
          productCategory: 'FLIGHT',
          direction: this.query.direction,
          outboundFlight: {
            ...value.outboundFlight,
            passengers: {
              adults: 2,
              children: 0,
            },
          },
          returnFlight: {
            ...value.returnFlight,
            passengers: {
              adults: 2,
              children: 0,
            },
          },
          totalPrice: this.totalPrice,
        });
      }
    } else {
      if (value.outboundFlight) {
        this.addToCart({
          type: 'FLIGHT',
          productCategory: 'FLIGHT',
          direction: this.query.direction,
          outboundFlight: {
            ...value.outboundFlight,
            passengers: {
              adults: 2,
              children: 0,
            },
          },
          totalPrice: this.totalPrice,
        });
      }
    }
  }

  abortFilterFn() {
    return;
  }

  async departureFilterFn(val: string, update: any, abort: any) {
    try {
      // const { data: airports } = await compass.do('geo', 'find', {
      //   filter: {
      //     $or: [
      //       { name: { $regex: '(^|\\s)' + val, $options: 'i' } },
      //       { iataCode: { $regex: '(^|\\s)' + val, $options: 'i' } },
      //     ],
      //     'feature.code': 'AIRP',
      //   },
      // });

      const { data: airports } = await compass.do('integrations', 'flightDepartures', {
        data: {
          currency: 'TRY', // this.market.currency,
          isRoundTrip: this.query.direction === 'ROUND_TRIP',
          language: this.$i18n.locale,
          query: val,
        },
      });

      update(
        () =>
          (this.airportAutocompletes.departure = [...new Set(airports.flat())].map((i) => {
            return {
              label: i.name,
              value: i.id,
            };
          })),
      );
    } catch (err) {
      return;
    }
  }

  async arrivalFilterFn(val: string, update: any, abort: any) {
    try {
      const province = this.property.address.province as any;

      const { data: airports } = await compass.do('geo', 'find', {
        filter: {
          $or: [
            { name: { $regex: '(^|\\s)' + val, $options: 'i' } },
            { iataCode: { $regex: '(^|\\s)' + val, $options: 'i' } },
          ],
          countryCode: province.countryCode,
          admin1: province.admin1,
          'feature.code': 'AIRP',
          location: {
            $near: province.location,
            $maxDistance: 300000,
          },
        },
      });

      update(
        () =>
          (this.airportAutocompletes.arrival = [...new Set(airports.flat())].map((i) => {
            return {
              label: i.name,
              value: i.iataCode,
            };
          })),
      );
    } catch (err) {
      return;
    }
  }

  searchFlights() {
    this.isSearchingFlights = true;

    const product = this.products.find((p) => p.type !== 'FLIGHT') as IProductProperty;
    const checkInDate = moment(product.checkInDate);
    const checkOutDate = moment(product.checkOutDate);

    let passengers = [
      {
        type: 'ADULT',
        count: product.adults.length,
      },
    ];

    if (product.children.length > 0) {
      passengers.push({
        type: 'CHILD',
        count: product.children.length,
      });
    }

    compass
      .do('integrations', 'flightPrices', {
        data: {
          currency: 'TRY', // this.market.currency,
          isRoundTrip: this.query.direction === 'ROUND_TRIP',
          language: this.$i18n.locale,
          departure: {
            id: this.query.departure,
            type: 'AIRPORT',
          },
          arrival: {
            id: this.query.arrival,
            type: 'AIRPORT',
          },
          checkIn: checkInDate.toISOString(),
          nights: checkOutDate.diff(checkInDate, 'days'),
          passengers: passengers as PassengerDto[],
        },
      })
      .then((res) => {
        const { outboundFlights = [], returnFlights = [] } = res.data;
        this.selected.outboundFlight = null;
        this.selected.returnFlight = null;

        this.notFound = !outboundFlights.length;
        this.offers = {
          outboundFlights,
          returnFlights,
        };
      })
      .finally(() => {
        this.isSearchingFlights = false;
      });
  }
}
